"use strict";

var pivotTableCtrl = [
  "graphDataFactory",
  "$scope",
  "$timeout",
  function (graphDataFactory, $scope, $timeout) {
    var _this = this;
    _this.waitingData = true;
    _this._pivotLoadSeq = 0;
    google.load("visualization", "1", {
      packages: ["corechart", "charteditor"],
    });
    _this.cssPanel = "";
    _this.cssPivot = "";
    _this.edit = false;
    var pivotIdSuffix = _this.graphDomSuffix || "";
    _this.pivotObjectId = "pivot-".concat(_this.element.id).concat(pivotIdSuffix);
    _this.pivotObject = "#".concat(_this.pivotObjectId);

    function layoutH() {
      var v = _this.layoutViewport;
      if (v && v.height > 0) return v.height;
      return window.innerHeight;
    }
    function layoutW() {
      var v = _this.layoutViewport;
      if (v && v.width > 0) return v.width;
      return window.innerWidth;
    }

    function isMaximizeViewport() {
      return _this.layoutViewport && _this.layoutViewport.height > 0;
    }
    _this.element.partsOfWindowWidth = _this.element.partsOfWindowWidth || 1;
    _this.element.partsOfWindowHeight = _this.element.partsOfWindowHeight || 1;
    _this.element.templateData = _this.element.templateData || {};
    _this.element.templateData.xaxis = _this.element.templateData.xaxis || {};
    _this.element.templateData.yaxis = _this.element.templateData.yaxis || {};
    if (_this.element.templateData.xaxis.type == null) _this.element.templateData.xaxis.type = "";
    if (_this.element.templateData.yaxis.type == null) _this.element.templateData.yaxis.type = "";

    // Background general
    _this.element.backgroundColor = _this.element.backgroundColor || "#ffffff";

    // Header principal - Gris muy suave
    _this.element.backgroundTitleColor = _this.element.backgroundTitleColor || "#f8fafc";
    _this.element.borderTitleColor = _this.element.borderTitleColor || "#e2e8f0";
    _this.element.titleColor = _this.element.titleColor || "#475569";
    _this.element.titleFontSize = _this.element.titleFontSize || 10;

    // Header lateral - Aún más suave
    _this.element.backgroundTitleLeftColor = _this.element.backgroundTitleLeftColor || "#f1f5f9";
    _this.element.borderTitleLeftColor = _this.element.borderTitleLeftColor || "#e2e8f0";
    _this.element.titleLeftColor = _this.element.titleLeftColor || "#64748b";
    _this.element.titleLeftFontSize = _this.element.titleLeftFontSize || 10;

    // Filas impares
    _this.element.backgroundOddColor = _this.element.backgroundOddColor || "#ffffff";
    _this.element.borderOddColor = _this.element.borderOddColor || "#f8fafc";
    _this.element.oddColor = _this.element.oddColor || "#374151";
    _this.element.oddFontSize = _this.element.oddFontSize || 10;

    // Filas pares
    _this.element.backgroundEvenColor = _this.element.backgroundEvenColor || "#fafbfb"; //f9fafb
    _this.element.borderEvenColor = _this.element.borderEvenColor || "#f8fafc";
    _this.element.evenColor = _this.element.evenColor || "#374151";
    _this.element.evenFontSize = _this.element.evenFontSize || 10;

    // Totales - Gris medio muy suave
    _this.element.backgroundTotalColor = _this.element.backgroundTotalColor || "#e2e8f0";
    _this.element.borderTotalColor = _this.element.borderTotalColor || "#cbd5e1";
    _this.element.totalColor = _this.element.totalColor || "#1e293b";
    _this.element.totalFontSize = _this.element.totalFontSize || 10;

    // Gran total - Un tono más oscuro pero suave
    _this.element.backgroundGTotalColor = _this.element.backgroundGTotalColor || "#cbd5e1";
    _this.element.borderGTotalColor = _this.element.borderGTotalColor || "#94a3b8";
    _this.element.gtotalColor = _this.element.gtotalColor || "#1e293b";
    _this.element.gtotalFontSize = _this.element.gtotalFontSize || 10;

    _this.resetTable = function () {
        _this.element.backgroundColor = _this.element.backgroundColor || "#ffffff";
        
        // Header principal - Gris muy suave
        _this.element.backgroundTitleColor = "#f8fafc";
        _this.element.borderTitleColor = "#e2e8f0";
        _this.element.titleColor = "#475569";
        _this.element.titleFontSize = 10;

        // Header lateral - Aún más suave
        _this.element.backgroundTitleLeftColor = "#f1f5f9";
        _this.element.borderTitleLeftColor = "#e2e8f0";
        _this.element.titleLeftColor = "#64748b";
        _this.element.titleLeftFontSize = 10;

        // Filas impares
        _this.element.backgroundOddColor = "#ffffff";
        _this.element.borderOddColor = "#f8fafc";
        _this.element.oddColor = "#374151";
        _this.element.oddFontSize = 10;

        // Filas pares
        _this.element.backgroundEvenColor = "#fafbfb"; //f9fafb
        _this.element.borderEvenColor = "#f8fafc";
        _this.element.evenColor = "#374151";
        _this.element.evenFontSize = 10;

        // Totales - Gris medio muy suave
        _this.element.backgroundTotalColor = "#e2e8f0";
        _this.element.borderTotalColor = "#cbd5e1";
        _this.element.totalColor = "#1e293b";
        _this.element.totalFontSize = 10;

        // Gran total - Un tono más oscuro pero suave
        _this.element.backgroundGTotalColor = "#cbd5e1";
        _this.element.borderGTotalColor = "#94a3b8";
        _this.element.gtotalColor = "#1e293b";
        _this.element.gtotalFontSize = 10;
    }

    _this.isTable = () => {
      return [
        "Table",
        "Table Barchart",
        "Heatmap",
        "Row Heatmap",
        "Col Heatmap",
      ].includes(_this.pivotConfig.rendererName);
    };
    _this.isIndicator = () => {
      return ["Indicator"].includes(_this.pivotConfig.rendererName);
    };

    _this.isChart = () => {
      return [
        "Bar Chart",
        "Stacked Bar Chart",
        "Line Chart",
        "Area Chart",  
        "Horizontal Bar Chart",  
        "Horizontal Stacked Bar Chart",
        "Scatter Chart"
      ].includes(_this.pivotConfig.rendererName);
    };

    _this.isScatter = () => {
      return _this.pivotConfig.rendererName === "Scatter Chart";
    };

    _this.isBarChart = () => {
      return [
        "Bar Chart",
        "Stacked Bar Chart",
        "Horizontal Bar Chart",
        "Horizontal Stacked Bar Chart",
      ].includes(_this.pivotConfig.rendererName);
    };

    _this.blockBarChartRightClick = () => {
      const root = document.querySelector(_this.pivotObject);
      if (!root) return;
      const plot = root.querySelector(".js-plotly-plot");
      if (!plot || plot._barRightClickBlocked) return;
      if (!_this.isBarChart()) return;
      plot._barRightClickBlocked = true;
      const blockRightClick = (event) => {
        if (event.button !== 2 && event.which !== 3) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      };
      plot.addEventListener("mousedown", blockRightClick, true);
      plot.addEventListener("mouseup", blockRightClick, true);
      plot.addEventListener("contextmenu", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }, true);
    };

    _this.isPie = () => {
      return [
        "Multiple Pie Chart",
        "Multiple Pie Chart2",
      ].includes(_this.pivotConfig.rendererName);
    };

    $scope.applyGrandTotalBGColor = function () {
      let style = {
        "background-color": _this.element.backgroundGTotalColor,
        color: _this.element.gtotalColor,
        "font-size": _this.element.gtotalFontSize + "px",
        // border: "1px solid " + _this.element.borderGTotalColor,
        "border": "none"
      };
      $(_this.pivotObject)
        .find(".pvtTable")
        .children("tbody")
        .children("tr")
        .find("td.pvtGrandTotal")
        .css(style);
    };

    $scope.applyColumnTotalBGColor = function () {
      let style = {
        "background-color": _this.element.backgroundTotalColor,
        color: _this.element.totalColor,
        "font-size": _this.element.totalFontSize + "px",
        // border: "1px solid " + _this.element.borderTotalColor,
        "border-bottom": "1px solid " + _this.element.borderTotalColor,
        "border-top": "none",
        "border-left": "none",
        "border-right": "none"
      };
      $(_this.pivotObject)
        .find(".pvtTable")
        .children("tbody")
        .children("tr")
        .find("td.rowTotal")
        .each(function () {
          $(this).css(style);
        });

      $(_this.pivotObject)
        .find(".pvtTable")
        .children("tbody")
        .children("tr")
        .find("th.pvtTotalLabel")
        .css(style);

      $(_this.pivotObject)
        .find(".pvtTable")
        .children("thead")
        .children("tr")
        .find("th.pvtTotalLabel")
        .css(style);

      $(_this.pivotObject)
        .find(".pvtTable")
        .children("tbody")
        .children("tr")
        .find("td.colTotal")
        .each(function () {
          $(this).css(style);
        });
    };

    $scope.applyZebra = function () {
      $(_this.pivotObject)
        .find(".pvtTable tbody tr:nth-child(even)")
        .find(".pvtVal")
        .each(function () {
          $(this).css({
            "background-color": _this.element.backgroundEvenColor,
            color: _this.element.evenColor,
            "font-size": _this.element.evenFontSize + "px",
            // border: "1px solid " + _this.element.borderEvenColor,
            "border-bottom": "1px solid " + _this.element.borderEvenColor,
            "border-top": "none",
            "border-left": "none",
            "border-right": "none"
          });
        });
      $(_this.pivotObject)
        .find(".pvtTable tbody tr:nth-child(odd)")
        .find(".pvtVal")
        .each(function () {
          $(this).css({
            "background-color": _this.element.backgroundOddColor,
            color: _this.element.oddColor,
            "font-size": _this.element.oddFontSize + "px",
            // border: "1px solid " + _this.element.borderOddColor,
            "border-bottom": "1px solid " + _this.element.borderOddColor,
            "border-top": "none",
            "border-left": "none",
            "border-right": "none"
          });
        });
    };

    $scope.applySticky = function () {
      if ($scope.stickyheader) {
        $(_this.pivotObject).find(".pvtTable").children("thead").css({
          position: "sticky",
          top: "0",
          "z-index": "10",
          "background-color": _this.element.backgroundTitleColor,
        });
      } else {
        $(_this.pivotObject).find(".pvtTable").children("thead").css({
          position: "",
        });
      }
    };

    $scope.applyLeftLabelBGColor = function (val) {
      $scope.leftheaderbgcolor = val;
      if (val != "") {
        $(_this.pivotObject)
          .find(".pvtTable")
          .children("tbody")
          .children("tr")
          .find("th")
          .each(function () {
            $(this).css({
              "background-color": _this.element.backgroundTitleLeftColor,
              color: _this.element.titleLeftColor,
              "font-size": _this.element.titleLeftFontSize + "px",
                // border: "1px solid " + _this.element.borderTitleLeftColor,
                "border-right": "1px solid " + _this.element.borderTitleLeftColor,
                "border-bottom": "1px solid " + _this.element.borderTitleLeftColor,
                "border-top": "none",
                "border-left": "none"
            });
          });
      }
    };

    $scope.applyTopLabelBGColor = function (val) {
      $(_this.pivotObject)
        .find(".pvtTable")
        .children("thead")
        .children("tr")
        .find("th")
        .each(function () {
          $(this).css({
            "background-color": _this.element.backgroundTitleColor,
            color: _this.element.titleColor,
            "font-size": _this.element.titleFontSize + "px",
            // border: "1px solid " + _this.element.borderTitleColor,
            "border-right": "1px solid " + _this.element.borderTitleColor, // Solo borde derecho
            "border-top": "none",
            "border-left": "none", 
            "border-bottom": "none"
          });
        });
    };

    $scope.applyPanelBackground = function () {
        // Background color contenedor del pivot
        $(_this.pivotObject).css({
            'background-color': _this.element.backgroundColor
        });

        // Background color contenedor pvtRendererArea
        $(_this.pivotObject).find('.pvtRendererArea').css({
            'background-color': _this.element.backgroundColor
        });
    };

    let rendererOptions = {
      table: { rowTotals: $scope.rowTotals, colTotals: $scope.colTotals },
    };

    _this.pivotConfigDefault = {
      autoSortUnusedAttrs: false,
      exclusions: {},
      hiddenAttributes: [],
      rendererOptions: rendererOptions,
      derivedAttributes: {},
      colOrder: "key_a_to_z",
      rowOrder: "key_a_to_z",
      sorters: {},
    };

    _this.pivotConfig = _this.element.pivotConfig || _this.pivotConfigDefault;

    _this.pivotConfig.showUI = _this.edit;
    _this.pivotConfig.onRefresh = function (config) {
      if (_this.editenabled == true && _this.edit==true) _this.savePivot();
      $scope.applyTopLabelBGColor();
      $scope.applyLeftLabelBGColor();
      $scope.applyZebra();
      $scope.applyColumnTotalBGColor();
      $scope.applyGrandTotalBGColor();
      $scope.applySticky();
      $scope.applyPanelBackground();
      
      if (_this.isIndicator() && _this.editenabled === undefined) {
        let height;
        if (isMaximizeViewport()) {
          height = layoutH() - 28;
        } else if (_this.element.heightMode === 'percentage' && _this.element.heightPercentage !== undefined) {
          let percentage = parseFloat(_this.element.heightPercentage) || 100;
          percentage = Math.max(0, Math.min(100, percentage));
          height = (layoutH() * percentage / 100);
        } else {
          let parts = parseFloat(_this.element.partsOfWindowHeight) || 1;
          height = layoutH() / parts;
        }
        _this.applyHeightBasedFontSize(height);
      }

      $timeout(_this.blockBarChartRightClick, 0);
      $timeout(_this.blockBarChartRightClick, 100);
      return;
    };

    this.pivotConfig.renderers = $.extend(
      $.pivotUtilities.renderers,
      $.pivotUtilities.plotly_renderers,
      //$.pivotUtilities.gchart_renderers,
      $.pivotUtilities.export_renderers
    );

    _this.savePivot = function () {
      let config = $(_this.pivotObject).data("pivotUIOptions");
      let config_copy = JSON.parse(JSON.stringify(config));
      delete config_copy["aggregators"];
      delete config_copy["renderers"];
      delete config_copy["onRefresh"];
      delete config_copy["rendererOptions"];
      delete config_copy["localeStrings"];

      _this.element.pivotConfig = config_copy;
      _this.pivotConfig = config;
    };

    // For null values in pivot table data
    function processDataForNulls(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return data;
      }
      const pivotAxesColumns = [
        ...(_this.pivotConfig.rows || []),
        ...(_this.pivotConfig.cols || []),
      ];
      if (pivotAxesColumns.length === 0) {
        return data;
      }
      const transformedData = data.map((row) => {
        const newRow = { ...row };
        for (const colName of pivotAxesColumns) {
          if (newRow.hasOwnProperty(colName) && (newRow[colName] === null || newRow[colName] === undefined || newRow[colName] === '')) {
            newRow[colName] = '(Vacío)';
          }
        }
        return newRow;
      });

      return transformedData;
    }

    const hasAxisBound = (value) => value !== null && value !== undefined && value !== '';

    const axisBound = (value) => {
      if (!hasAxisBound(value)) return null;
      const num = Number(value);
      return isNaN(num) ? String(value) : num;
    };

    // '.2%' (y el valor viejo entre comillas) multiplica por 100 en Plotly.
    // Los valores del eje ya están en la unidad que se quiere mostrar.
    const axisTickFormat = (tickformat) => {
      if (!tickformat) return null;
      if (tickformat === "'.2%'" || tickformat === '.2%') {
        return { tickformat: ',.2f', ticksuffix: '%' };
      }
      if (tickformat === 'd') {
        return { tickformat: ',.0f', exponentformat: 'none' };
      }
      return { tickformat: tickformat, exponentformat: 'none' };
    };

    _this.loadPivot = function (forceUpdateData = false) {
      function setAxisProps(axis) {
        if(_this.element.templateData && _this.element.templateData[axis]){
          _this.pivotConfig.rendererOptions[axis] =  {}
          const renderOpts = _this.pivotConfig.rendererOptions[axis];
          const tplData = _this.element.templateData[axis];
          if (tplData.title)
            renderOpts.title = tplData.title;
          const tickFormat = axisTickFormat(tplData.tickformat);
          const dateAxis = tplData.type === "date" || (tickFormat && String(tickFormat.tickformat).charAt(0) === "%");
          const rangeBound = (value) => {
            if (!hasAxisBound(value)) return null;
            if (dateAxis) return String(value).trim();
            return axisBound(value);
          };
          const minBound = rangeBound(tplData.min);
          const maxBound = rangeBound(tplData.max);
          if (minBound !== null || maxBound !== null)
            renderOpts.range = [minBound, maxBound];
          if (tickFormat) Object.assign(renderOpts, tickFormat);
          if (_this.element.templateData?.dataOrder)
            renderOpts.dataOrder = _this.element.templateData.dataOrder;
          if (_this.element.templateData?.dataQuantity)
            renderOpts.dataQuantity = _this.element.templateData.dataQuantity;
      }
    }
        _this.waitingData = true;
      _this.pivotConfig.showUI = _this.edit;
      _this.pivotConfig.rendererOptions =
        _this.pivotConfigDefault.rendererOptions;
        _this.pivotConfig.rendererOptions.referenceColors =
        _this.element.templateData.referenceColors || [];
      _this.pivotConfig.rendererOptions.showlegend =
        _this.element.templateData.showlegend == true;
      setAxisProps("yaxis");
      setAxisProps("xaxis");
      // El renderer Scatter solo copia opts.plotly sobre el layout, no opts.xaxis/yaxis.
      const applyScatterAxisLayout = () => {
        delete _this.pivotConfig.rendererOptions.plotly;
        if (!_this.isScatter()) return;
        const allowedScales = ["linear", "log", "date", "category"];
        const tpl = _this.element.templateData || {};
        const plotly = {};
        const axisNames = {};
        [
          { axis: "xaxis", attrs: _this.pivotConfig.cols },
          { axis: "yaxis", attrs: _this.pivotConfig.rows },
        ].forEach((spec) => {
          const axisTpl = tpl[spec.axis] || {};
          const fallback = Array.isArray(spec.attrs) ? spec.attrs.join("-") : "";
          const title = (axisTpl.title || "").trim();
          const hasScale = allowedScales.includes(axisTpl.type);
          const tickFormat = axisTickFormat(axisTpl.tickformat);
          const dateAxis = axisTpl.type === "date" || (tickFormat && String(tickFormat.tickformat).charAt(0) === "%");
          const hasRange = hasAxisBound(axisTpl.min) || hasAxisBound(axisTpl.max);
          axisNames[spec.axis] = title || fallback;
          if (!hasScale && !title && !tickFormat && !hasRange) return;
          const axisLayout = {
            title: title || fallback,
            automargin: true,
          };
          if (hasScale) axisLayout.type = axisTpl.type;
          if (tickFormat) Object.assign(axisLayout, tickFormat);
          if (hasRange) {
            const toRangeBound = (raw) => {
              if (!hasAxisBound(raw)) return null;
              if (dateAxis) return String(raw).trim();
              const num = Number(raw);
              if (isNaN(num)) return String(raw).trim();
              if (axisTpl.type === "log") {
                if (num <= 0) return null;
                return Math.log10(num);
              }
              return num;
            };
            const range = [toRangeBound(axisTpl.min), toRangeBound(axisTpl.max)];
            if (range[0] !== null || range[1] !== null) {
              axisLayout.autorange = false;
              axisLayout.range = range;
            }
          }
          plotly[spec.axis] = axisLayout;
        });
        const yTitle = (tpl.yaxis && tpl.yaxis.title || "").trim();
        const xTitle = (tpl.xaxis && tpl.xaxis.title || "").trim();
        if (yTitle || xTitle) {
          plotly.title = axisNames.yaxis + " vs " + axisNames.xaxis;
        }
        if (Object.keys(plotly).length > 0) {
          _this.pivotConfig.rendererOptions.plotly = plotly;
        }
      };
      applyScatterAxisLayout();
      _this.pivotConfig.rendererOptions.color = _this.element.color;
      _this.pivotConfig.rendererOptions.indicatorText =
        _this.element.indicatorText;
      _this.pivotConfig.rendererOptions.autoScale = _this.element.autoScale
      _this.pivotConfig.rendererOptions.decimalPlaces = _this.element.decimalPlaces
      if (_this.editenabled == undefined) {
        _this.cssPanel = "";
        _this.cssPivot = "";
        let height;
        let availableWidth = layoutW() - 40;
        let width;

        if (isMaximizeViewport()) {
          height = layoutH();
          width = Math.max(200, availableWidth - 16);
        } else if (_this.element.heightMode === 'percentage' && _this.element.heightPercentage !== undefined) {
            let percentage = parseFloat(_this.element.heightPercentage) || 100;
            percentage = Math.max(0, Math.min(100, percentage));
            height = (layoutH() * percentage / 100);
        } else {
            let parts = parseFloat(_this.element.partsOfWindowHeight) || 1;
            height = layoutH() / parts;
        }

        if (!isMaximizeViewport()) {
          if (_this.element.widthMode === 'percentage' && _this.element.widthPercentage !== undefined) {
            let percentage = parseFloat(_this.element.widthPercentage) || 100;
            percentage = Math.max(0, Math.min(100, percentage));
            width = (availableWidth * percentage / 100) - 40;
          } else {
            let parts = parseFloat(_this.element.partsOfWindowWidth) || 2;
            width = availableWidth / parts - 40;
          }
        }
        
        _this.pivotConfig.rendererOptions.width = width;
        var chartHeightSubtract = isMaximizeViewport() ? 52 : 80;
        _this.pivotConfig.rendererOptions.height = height - chartHeightSubtract;
        _this.cssPanel += "height:".concat((height).toFixed(), "px;");
        _this.cssPivot += "height:".concat((height - 30 - 41).toFixed(), "px;");
        
        _this.applyHeightBasedFontSize(height);
      } else {
        let widthTotal = window.innerWidth * 0.8 - 150;
        _this.pivotConfig.rendererOptions.width = widthTotal - (_this.edit ? 210 : 0);
        _this.pivotConfig.rendererOptions.height = window.innerHeight * 0.4 - 10;
        _this.cssPivot += "width:".concat(widthTotal.toFixed(), "px;");
        _this.cssPivot += "height:".concat((_this.pivotConfig.rendererOptions.height + (_this.edit ? 130 : 10)).toFixed(), "px;");
        // Adjust height for graph builder
        _this.cssPivot += "overflow: auto;";
        _this.cssPivot += "min-height:".concat((35).toFixed(), "vh;");
        _this.cssPivot += "max-height: calc(65vh - 40px) !important;";       
        _this.cssPanel += "min-height:".concat((35).toFixed(), "vh;");
        _this.cssPanel += "max-height:".concat((65).toFixed(), "vh;");
        _this.applyHeightBasedFontSize(window.innerHeight * 0.4);
      }
      _this.pivotConfig.rendererOptions.width;
      if (_this.element.templateData.datasourceElementId) {
        const loadSeq = ++_this._pivotLoadSeq;
        _this.waitingData = true;
        graphDataFactory
          .getData(
            _this.element.templateData.datasourceElementId,
            forceUpdateData
          )
          .then(function (data) {
            if (loadSeq !== _this._pivotLoadSeq) return;
            if (data && data.cancelled) return;
            if (!Array.isArray(data)) {
              _this.waitingData = false;
              _this.loading = false;
              return;
            }
            _this.data = processDataForNulls(data);
            try {
              $(_this.pivotObject).pivotUI(
                _this.data,
                _this.pivotConfig,
                true,
                "es"
              );
            } catch (e) {
              console.error("pivotUI Error: ", e);
            }
            $timeout(() => {
              if (loadSeq !== _this._pivotLoadSeq) return;
              _this.waitingData = false;
              _this.loading = false;
            }, 100);
          })
          .catch(function (e) {
            if (loadSeq !== _this._pivotLoadSeq) return;
            _this.waitingData = false;
            _this.loading = false;
          });
      } else if (Array.isArray(_this.element.templateData.data)) {
        // _this.data = _this.element.templateData.data;

        // Llama a la nueva función genérica para procesar la data
        _this.data = processDataForNulls(_this.element.templateData.data);

        $(_this.pivotObject).pivotUI(_this.data, _this.pivotConfig, true, "es");
        _this.waitingData = false;
      }
    };

    $scope.$on("graph-reloadData-loading", function (event, forceUpdateData) {
        _this.loading = true;
        _this.waitingData = true;
    });
    $scope.$on("graph-reloadData", function (event, forceUpdateData) {
        _this.loading = false;
        _this.waitingData = true;
        $timeout(() => _this.loadPivot(forceUpdateData), 0);
    });

    _this.applyHeightBasedFontSize = function(height) {
      if (!_this.isIndicator() || _this.editenabled !== undefined) {
        return;
      }
      
      $timeout(() => {
        const pivotPanel = document.querySelector('#' + _this.pivotObjectId)?.closest('.pivot-panel');
        if (pivotPanel) {
          const numberDiv = pivotPanel.querySelector('.pvtRendererArea > div:first-child');
          if (numberDiv) {
            let fontSize;
            if (height < 100) {
              fontSize = 'clamp(8px, 4vh, 30px)';
            } else if (height < 150) {
              fontSize = '40px';
            } else {
                // fontSize = '10vh';
                fontSize = Math.min(height * 0.35, 120) + 'px';
            }            
            numberDiv.style.setProperty('font-size', fontSize, 'important');
          }
        }
      }, 100);
    };

    _this.exportToCSV = () => {
      console.log("exportToCSV");
      if (Array.isArray(_this.data) && _this.data.length > 0) {
        const jsonKeys = Object.keys(_this.data[0]);
        let json2CSV = jsonKeys.join(",") + "\n";
        for (var i = 0; i < _this.data.length; i++) {
          var row = "";
          for (const key of jsonKeys) {
            if (row !== "") {
              row += ",";
            }
            row += _this.data[i][key];
          }
          json2CSV += row + "\n";
        }
        var exportedFilenmae = _this.element.name + ".csv" || "export.csv";

        var blob = new Blob([json2CSV], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            // feature detection
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }
    };
    $scope.$watch(
      function () {
        if (!_this.layoutViewport || !_this.layoutViewport.height) {
          return null;
        }
        return (
          (_this.layoutViewport.width || 0) +
          "x" +
          (_this.layoutViewport.height || 0)
        );
      },
      function (nv, ov) {
        if (!nv || nv === ov || !ov) {
          return;
        }
        if (_this.editenabled === undefined) {
          $timeout(function () {
            _this.loadPivot(false);
          }, 0);
        }
      }
    );

    _this.loadPivot();
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      element: "=",
      editenabled: "=",
      layoutViewport: "=?",
      graphDomSuffix: "@",
    },
    replace: true,
    controller: pivotTableCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "pivotTable-directive/pivotTableDirective.html",
  };
};
